import React from 'react';
import Menu from '../Menu';

import './SideDrawerStyles.scss';

const SideDrawer = ({links, pos, classes, click}) => {
    const open = classes === 'collapse show';
    return (
        <nav className={`side-drawer-container ${open ?  'open' : ''}`}>
            <div className="header-container">
                <button onClick={click}>
                    <i className="la la-angle-double-left" />
                </button>
            </div>
            <ul className="navbar-nav">
                <Menu links={links} pos={pos} />
            </ul>
        </nav>
    );
};

export default SideDrawer;